import { render, staticRenderFns } from "./CancelOrRefundModal.vue?vue&type=template&id=c2765e48&scoped=true&"
import script from "./CancelOrRefundModal.vue?vue&type=script&lang=js&"
export * from "./CancelOrRefundModal.vue?vue&type=script&lang=js&"
import style0 from "./CancelOrRefundModal.vue?vue&type=style&index=0&id=c2765e48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2765e48",
  null
  
)

export default component.exports